import { styled } from "@mui/material/styles";
import { Box, Typography, TextField } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const InputContainer = styled(Box)(({ fullWidth }) => ({
  width: fullWidth ? "100%" : "auto",
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  position: "relative",
}));

export const Label = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "11px",
  fontWeight: 500,
  lineHeight: "1.2",
  marginBottom: "2px",

  "& .required": {
    color: theme.palette.error.main,
    marginLeft: "2px",
  },
}));

export const StyledInput = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    fontSize: "12px",
    height: "32px",
    borderRadius: "5px",
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),

    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
      WebkitTextFillColor: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      transition: "background-color 5000s ease-in-out 0s",
    },

    "&:-webkit-autofill:hover": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
    },

    "&:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
    },

    "&:-webkit-autofill:active": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
    },

    "& fieldset": {
      borderColor: theme.palette.divider,
      borderWidth: "1px !important",
    },

    "&:hover fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px !important",
    },

    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: "1px !important",
    },

    "&.Mui-error fieldset": {
      borderColor: theme.palette.error.main,
      borderWidth: "1px !important",
    },

    "&.Mui-disabled": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.action.disabled, 0.1)
          : alpha(theme.palette.action.disabled, 0.05),
      cursor: "not-allowed",

      "& fieldset": {
        borderColor:
          theme.palette.mode === "dark"
            ? alpha(theme.palette.grey[600], 0.3)
            : theme.palette.grey[300],
      },

      "& input": {
        color: theme.palette.text.disabled,
        WebkitTextFillColor: theme.palette.text.disabled,
        "&::placeholder": {
          color: theme.palette.text.disabled,
          opacity: 0.5,
        },
      },
    },
  },

  "& .MuiInputBase-input": {
    padding: "4px 12px",
    height: "24px !important",
    lineHeight: "24px",
    boxSizing: "border-box",
    fontSize: "12px",

    "&::placeholder": {
      color: theme.palette.text.secondary,
      opacity: 0.7,
      fontSize: "12px",
    },

    "&:disabled": {
      cursor: "not-allowed",
    },
  },

  "& .MuiInputBase-multiline": {
    height: "auto !important",
    padding: "8px 12px",

    "& textarea": {
      height: "auto !important",
      lineHeight: "1.5",
      padding: "0 !important",
      fontSize: "12px",
    },
  },

  // Date input specific styles
  '& input[type="date"]': {
    height: "24px !important",
    "&::-webkit-calendar-picker-indicator": {
      cursor: "pointer",
      filter: theme.palette.mode === "dark" ? "invert(1)" : "none",
      opacity: 0.7,

      "&:hover": {
        opacity: 1,
      },
    },
  },

  // Hover state
  "&:hover .MuiOutlinedInput-root": {
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.common.white, 0.03)
        : alpha(theme.palette.common.black, 0.02),
  },

  // Focus state
  "& .MuiOutlinedInput-root.Mui-focused": {
    boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.08)}`,
  },
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: "12px",
  marginTop: "4px",
  lineHeight: 1.2,
}));
